module.exports = __webpack_public_path__ + "79cb6a305cf972798f718d967671df31.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/Foto_Manja_Herrmann-8352_klein.jpg
// module id = 600
// module chunks = 0